import type { SavingsDataViewProps } from './savings-data-view';
import { SavingsDataView } from './savings-data-view';
import { SavingsEmptyView } from './savings-empty-view';
import { SavingsLoadingView } from './savings-loading-view';

interface SavingsContentProps extends Omit<SavingsDataViewProps, 'savedPerCategory'> {
  savedPerCategory: SavingsDataViewProps['savedPerCategory'] | undefined;
  totalSaved: number;
}

export function SavingsContent({ savedPerCategory, totalSaved, ...props }: Readonly<SavingsContentProps>) {
  const containerWidth = props.deviceWidth - 2 * props.containerMargin;
  if (!savedPerCategory) return <SavingsLoadingView containerWidth={containerWidth} />;
  if (savedPerCategory.length === 0 || totalSaved < 1) {
    return (
      <SavingsEmptyView containerWidth={containerWidth} transactionMode={props.transactionMode} type={props.type} />
    );
  }
  return <SavingsDataView {...props} savedPerCategory={savedPerCategory} />;
}
